export type CatalogSearchIndex = Record<string, {
  description?: string;
  translations: string[];
}>;

let index: CatalogSearchIndex | undefined;
let pending: Promise<void> | undefined;
const listeners = new Set<() => void>();

export function getCatalogSearchIndex(): CatalogSearchIndex | undefined {
  return index;
}

export function subscribeCatalogSearch(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

/** Search is cross-language; its generated data is independent of display text. */
export function loadCatalogSearch(): Promise<void> {
  if (index) return Promise.resolve();
  if (pending) return pending;
  pending = import("./catalog-text/search.json")
    .then(({ default: value }) => {
      index = value;
      listeners.forEach((listener) => listener());
    })
    .finally(() => { pending = undefined; });
  return pending;
}
